/**
 * @file Twitter URL validator
 * @author Wim Haanstra
 */
import { Validator } from 'breeze-client';
export var NAME_TWITTER_VALIDATOR = 'twitter';
/**
 * This validator validates the given URL
 */
export function TwitterValidator() {
    var contxt = {};
    var validator = new Validator(NAME_TWITTER_VALIDATOR, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        var stringValue = value;
        if (!stringValue) {
            return false;
        }
        var regularExpression = /^[a-zA-Z0-9_]{1,15}$/;
        return regularExpression.test(stringValue);
    }
}
Validator.messageTemplates[NAME_TWITTER_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.TWITTER';
Validator.register(TwitterValidator());
